import { Modifier, modifierToArray } from './Modifier';

const modifierSeparator = '--' as const;

/**
 * Gets a className and its BEM-Modifiers and returns a String which contains both.
 * Modifiers are short values ('green'); the full class name ('block--green') is composed here.
 * @param className {string} ClassName which will be extended
 * @param modifier {string|array} String or Array of short modifier values
 * @returns {string} Extended ClassName
 */
function bem<TClassName extends string, TVal extends string, TModifier extends Modifier<TVal>>(
  className: TClassName,
  modifier?: TModifier
): string {
  const extension = modifierToArray(modifier)
    .filter((m): m is TVal => !!m)
    .map(m => `${className}${modifierSeparator}${m}`)
    .join(' ');

  if (extension) {
    return `${className} ${extension}`;
  }

  return className;
}

bem.displayName = 'bem';

export default bem;
